import logo from './logo.svg';
import './App.css';
import SurveyComponent from './SurveyComponent'; // Importa tu componente de encuesta

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <SurveyComponent /> {/* Aquí se renderiza tu encuesta */}
      </header>
    </div>
  );
}

export default App;
